import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth13: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.1,50.9l.2-.2,7.8,22.6s-.3,21-.3,21.8-2.8,14.3-2.8,14.3l-4,15.8-4.5,9.5-4.3,10.3-2,8.8-1.5,9.5-2,10.8-1.3,2.5-5.8,4.3-4.5,2.8-4.5,2.5-6.8,2.3-6.3,2-6.5,2.5-4,.8-6-.3-4.8.8-8.8,2.3-5.5-.3-6.3-2.5-3.8-4-3.3-5.8-4.5-11-5.3-16-2-7.3-1.5-7.3-1.8-6.3-1.3-6.5-2-8.5-1.5-7.3-1.5-6.8-1-15.5-1-10.8-.5-19.8,1-11,.8-5,3.5-14.3,18.1-17.8L70.9.5l40.4,35.1,13.8,15.3h0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.1,50.9l.2-.2,7.8,22.6s-.3,21-.3,21.8-2.8,14.3-2.8,14.3l-4,15.8-4.5,9.5-4.3,10.3-2,8.8-1.5,9.5-2,10.8-1.3,2.5-5.8,4.3-4.5,2.8-4.5,2.5-6.8,2.3-6.3,2-6.5,2.5-4,.8-6-.3-4.8.8-8.8,2.3-5.5-.3-6.3-2.5-3.8-4-3.3-5.8-4.5-11-5.3-16-2-7.3-1.5-7.3-1.8-6.3-1.3-6.5-2-8.5-1.5-7.3-1.5-6.8-1-15.5-1-10.8-.5-19.8,1-11,.8-5,3.5-14.3,18.1-17.8L70.9.5l40.4,35.1,13.8,15.3h0Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.3,92.2a16.6,17.1 0 1,1 -33.2,0a16.6,17.1 0 1,1 33.2,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.1,83.4c-72.5,2.6-8.2,45.7-8.2,45.7l6.6-21.9,1.9-13.4-.2-10.4h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17,129.1l-2.4-9-1.9-11.1-1.6-12.2-.2-12.2c82.6,9.2,6.1,44.5,6.1,44.5Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112.4,169.9C80.8,88.8,80.8,9,80.8,9l16.3,12.2,14.1,15.3,14.1,16.5,7.1,19.5-.2,21.4-1.9,10.4-3.1,13-4.7,15.1-4.9,14.1-3.3,10.8-1.9,12.5h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.7,167l-1.9-3.3-2.6-9.4-2.4-14.6-3.5-13.2-3.8-17.2-.9-12-1.4-17.9.2-21.2,1.2-12.7,3.8-13.9L31.9,14.6l18.6-7.5c22.1,74.4-23.8,159.9-23.8,159.9Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.6,185.4c31.5,50.4,85.7,3.3,85.7,3.3l1.4-14.6-1.3,2.5-5.8,4.3-4.5,2.8-4.5,2.5-6.8,2.3-6.3,2-6.5,2.5-4,.8-6-.3-4.8.8-8.8,2.3-5.5-.3-6.3-2.5-3.8-4-3.3-5.8-4.5-11-5.3-16-2-7.3,2.8,35.7h.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '118.8 44 11.8 44 14.9 30.9 32.6 13.7 70.9 .7 106.3 29.7 117.3 42.9 118.8 44',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'12.1 87.2 25.7 107.4 29.4 79.1 41.8 112.8 51 79.1 62.4 114.6 72.8 81.3 84.2 114.6 94.4 80.9 105.4 114.6 113.9 81.8 120.2 108.7 132.9 89.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'56.1 418.3 66.7 405.7 54 397.6 69.2 389.8 55.2 381.1 70.6 372.8 56.4 365 71.3 356.5 57.1 347.1 71.5 337.1 59 329.8 73.4 321.1 60.6 312.6 76.2 310.2 63.2 302.9 78.4 297.2 67 288 79.4 284.1 68.7 276.7 78.9 269.5 68.2 262.1 81 253 69.9 245.4 81 237.4 69.7 229.6 82.1 220.8 70.2 212.4 83.4 202.7 71.8 194.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'40.9 281.4 47.4 295.5 53.9 281 61.5 296.8 69.3 281 75.8 297.6 82.9 283.8 88.8 295.5 93.9 282.7 98.6 296.8 102.6 283.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '130.2 101.2 128.4 111.5 124.8 119.1 120.4 127.3 117.1 129.9 110.4 137.8 107.1 141.9 103.8 145 98.9 148.8 95.8 152.2 87.4 158.1 82.5 160.6 74.1 163.4 62.8 163.2 58.5 161.1 52.3 158.3 43.6 152.4 41.3 149.6 38 143.7 30.8 136.3 18 124.8 14.7 121.4 10.3 113 9.8 109.2 8.5 105.1 9.3 98.1 11.1 91.2 13.9 85.1 26.7 72.5 44.9 57.4 59.2 49.8 69 47.5 89.7 47.2 108.1 54.6 118.4 64.3 123.5 73.6 128.9 88.7 130.2 101.2',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.5,74.4h48.6c-14.9-31.9-48.6,0-48.6,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '13.4 120 12.6 118.2 10.5 113.4 9.4 107.7 9.4 96.6 13.5 86.2 19 79.9 125.7 80.3 128.8 89.2 128.8 108.2 124.4 120 13.4 120',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.7,80.4c-66.7,18.7-1.3,39.7-1.3,39.7l4.3-11.9v-18.9s-3-9-3-9h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19,80c71.8,20.4-5.6,40.1-5.6,40.1l-2.9-6.6-1.1-5.8v-11.1s4.2-10.4,4.2-10.4l5.4-6.3h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.3,105.8c-60.3-18.1-119.4,1-119.4,1l.5-11.9,4.5-9.8,15.4-15.4,9.3-7.2,9.9-7.5,9.3-4.8,11.2-3.2,16.8.2,7.9,1.1,13.8,6.3,8.2,6.4,4.2,6.1,5.9,11.5,2.7,11.1-.2,16.2h0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.4,115l-2.6-8.2c69.2-19.6,119.4-1,119.4-1l-.5,4.8-1.8,6.6-4.3,8-7.1,8.8-7.2,7.1-7.1,6.1-10.7,9.5-9.8,5.1-6.4,1.6h-7.4s-3.2-.8-3.2-.8l-6.7-1.6-6.1-3.7-6.4-5.6-3-5-10.9-11.2-9.9-8.8-4-4.2-4.3-7.5h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'11.3 98.2 23.4 114.1 29.4 91.9 37.5 119 47.8 91.2 57.7 119 68.4 91.6 78.5 119 89.3 89.9 98.2 117.7 109.7 89.9 113.3 113.1 128.2 98.9',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.8,330.1h.2s3,14.8,3,14.8l1.9,10.3,4,12.9,6.3,15.4,3.8,12.2,3.6,20.3-1.1,24.3-7.2,16.7-11.4,12.9-15.8,17.1-13.1,10.1-11.8,7.6-5.9,2.7-35.9-13.1-16.5-16-6.1-15.8-1.3-9.5-.8-15,.6-37.1,1.9-14.4,2.5-19.2,2.1-14.1,1.1-11.4,1.3-1.9,2.7-3.8,2.7-3.2,3.4-4.9,5.3-4.4,2.7-1.7h4.4s2.7-1.5,2.7-1.5c0,0,6.5-5.1,7.2-5.5s9.1-3.4,9.1-3.4l7.4-2.3,6.5-2.5,3.2.4,4.4,1.9,6.3,2.7,9.1,5.3,17.5,13.1h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.8,330.1h.2s3,14.8,3,14.8l1.9,10.3,4,12.9,6.3,15.4,3.8,12.2,3.6,20.3-1.1,24.3-7.2,16.7-11.4,12.9-15.8,17.1-13.1,10.1-11.8,7.6-5.9,2.7-35.9-13.1-16.5-16-6.1-15.8-1.3-9.5-.8-15,.6-37.1,1.9-14.4,2.5-19.2,2.1-14.1,1.1-11.4,1.3-1.9,2.7-3.8,2.7-3.2,3.4-4.9,5.3-4.4,2.7-1.7h4.4s2.7-1.5,2.7-1.5c0,0,6.5-5.1,7.2-5.5s9.1-3.4,9.1-3.4l7.4-2.3,6.5-2.5,3.2.4,4.4,1.9,6.3,2.7,9.1,5.3,17.5,13.1h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.9,368.9l52.6-.2c-24.4-107.3-52.6.2-52.6.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.7,415.7l-1.3-10.4-2.4-13.5-4.7-13.5c-66.9,28.6,9.1,42.6,9.1,42.6',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.6,378.9c72.4,28-3.8,44.9-3.8,44.9v-4.7s.4-13.5.4-13.5l1.1-14,2.2-12.7h.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '53.7 503.1 32.8 494.4 24.2 485.7 18.4 481.1 15.7 476.6 107.9 476.6 101.2 483.7 87.5 495.3 69.5 507 53.7 503.1',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.8,337.6c-29.3,18.4-28.4,159.7-28.4,159.7l13.3-10.9,15.3-15.3,11.5-13.1,7.8-22.9.2-19.5-1.3-7.6-3.3-16.9-5.8-16.7-5.6-19.3-3.8-17.5h.1Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.4,341.8c38.8,16.9,30.4,157.9,30.4,157.9l-15.5-6.2-7.8-8.2-7.3-6.9-6.7-15.8-1.1-8.7-.9-15.1-.2-27.5.9-8.2,2.2-16.7,6-44.6h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111,316.3c-44-41.1-93.5,7.1-93.5,7.1l-1.6,18.4,1.3-1.9,5.4-7,3.4-4.9,8-6.1h4.4s9.9-7,9.9-7l9.1-3.4,7.4-2.3,6.5-2.5,3.2.4,19.8,9.9,17.5,13.1-.8-13.8h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'130.9 414.4 115.4 397 111.7 425.4 99.4 391.6 90.1 425.4 78.7 389.8 68.3 423.2 56.9 389.8 46.7 423.6 35.7 389.8 27.2 422.7 21 395.7 8.3 415',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'66.9 61.5 56 84.2 67.7 93.3 57.7 104.9 69.3 113 55.8 122.7 68.3 131.4 56.7 139.8 69.5 148.7 58 156.9 71 165.9 59.2 174.4 70.3 182.2 60.6 189.2 72 196.9 61.5 204.5 72.7 212.3 61.7 220.3 72.4 227.8 62.2 234.9 73 242.4 60.1 251.5 71.2 259 60.1 267.1 71.4 274.8 59 283.7 71 292.1 57.7 301.8 69.3 309.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'107 221.2 99.3 204.5 91.6 221.6 82.5 203 73.2 221.6 65.5 202 57.2 218.4 50.1 204.5 44.1 219.6 38.6 203 33.8 218.9',
			],
		},
	},
};
